import { Stack } from "@mui/material";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { FileInfo } from "../../../../api/types/fileTypes";
import EmptyFileDetailsPanel from "./EmptyFileDetailsPanel";
import MultipleFilesDetailsPanel from "./MultipleFilesDetailsPanel";
import SingleFileDetailsPanel from "./SingleFileDetailsPanel";

interface Props {
  files: FileInfo[];
}

const FileDetailsPanel = ({ files }: Props) => {
  const centerContent = files.length === 0;

  return (
    <Stack
      spacing={2}
      sx={{
        overflow: "auto",
        height: "100%",
        py: 2,
        px: 2.5,
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: "24rem",
        alignItems: centerContent ? "center" : "normal",
        justifyContent: centerContent ? "center" : "normal",
      }}
    >
      {files.length === 0 && <EmptyFileDetailsPanel />}
      {files.length === 1 && <SingleFileDetailsPanel catalogueId={defined(files[0]).catalogueId} />}
      {files.length > 1 && <MultipleFilesDetailsPanel files={files} />}
    </Stack>
  );
};

export default FileDetailsPanel;
